import React from 'react';
import './SubscriptionNotification.css';

const SubscriptionNotification = ({ warnings, onDismiss, onAction }) => {
    if (!warnings || warnings.length === 0) {
        return null;
    }

    const getSeverityClass = (severity) => {
        switch (severity) {
            case 'error':
                return 'notification-error';
            case 'warning':
                return 'notification-warning';
            case 'info':
                return 'notification-info';
            default:
                return 'notification-info';
        }
    };

    const getSeverityIcon = (severity) => {
        switch (severity) {
            case 'error':
                return '⚠️';
            case 'warning':
                return '⚠️';
            case 'info':
                return 'ℹ️';
            default:
                return 'ℹ️';
        }
    };

    const handleAction = (warning) => {
        if (onAction) {
            onAction(warning);
        }
    };

    return (
        <div className="subscription-notifications">
            {warnings.map((warning, index) => (
                <div 
                    key={index} 
                    className={`subscription-notification ${getSeverityClass(warning.severity)}`}
                >
                    <div className="notification-content">
                        <span className="notification-icon">
                            {getSeverityIcon(warning.severity)}
                        </span>
                        <span className="notification-message">
                            {warning.message}
                        </span>
                    </div>
                    
                    <div className="notification-actions">
                        {warning.type === 'trial' && (
                            <button
                                className="notification-action-btn primary"
                                onClick={() => handleAction(warning)}
                            >
                                Upgrade to Premium
                            </button>
                        )}

                        {warning.type === 'expired' && (
                            <button
                                className="notification-action-btn primary"
                                onClick={() => handleAction(warning)}
                            >
                                Reactivate
                            </button>
                        )}

                        <button
                            className="notification-action-btn secondary"
                            onClick={() => onDismiss && onDismiss(index)}
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SubscriptionNotification;
